import HistoryType from './HistoryType'

const historyReducer = (state, action) => {
  switch (action.type) {
    case HistoryType.GET_HISTORIES:
      return {
        ...state,
        histories: action.payload,
        loading: false,
      }
    case HistoryType.GET_HISTORY:
      return {
        ...state,
        history: action.payload,
        loading: false,
      }
    case HistoryType.CREATE_HISTORY:
      return {
        ...state,
        history: action.payload,
        loading: false,
      }
    case HistoryType.UPDATE_HISTORY:
      return {
        ...state,
        history: action.payload,
        loading: false,
      }
    case HistoryType.DELETE_HISTORY:
      return {
        ...state,
        history: {},
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default historyReducer
